import { fetchWithAuth } from "../../helpers/auth";

export const INPUT_SEARCH_KEYWORD = "INPUT_SEARCH_KEYWORD",
  SEARCH_REGISTRY_START = "SEARCH_REGISTRY_START",
  SEARCH_REGISTRY_SUCCESS = "SEARCH_REGISTRY_SUCCESS",
  SEARCH_REGISTRY_FAIL = "SEARCH_REGISTRY_FAIL",
  INPUT_SEARCH_QUERY = "INPUT_SEARCH_QUERY";

export const inputSearchKeyword = ({ keyword, view, collection }) => {
  return (dispatch) => {
    dispatch({
      type: INPUT_SEARCH_KEYWORD,
      keyword,
      view,
      collection,
    });
  };
};

export const inputSelectQuery = ({ field, value, view, collection }) => {
  return (dispatch) => {
    dispatch({
      type: INPUT_SEARCH_QUERY,
      field,
      value,
      view,
      collection,
    });
  };
};

const searchRegistryStart = ({ keyword, view, collection, role }) => {
  return {
    type: SEARCH_REGISTRY_START,
    keyword,
    view,
    collection,
    role,
  };
};

const searchRegistrySuccess = ({ keyword, view, collection, result, role }) => {
  return {
    type: SEARCH_REGISTRY_SUCCESS,
    keyword,
    view,
    collection,
    result,
    role,
  };
};

const searchRegistryFail = ({ keyword, view, collection, error, role }) => {
  return {
    type: SEARCH_REGISTRY_FAIL,
    keyword,
    view,
    collection,
    error,
    role,
  };
};

export const searchStudent = ({
  keyword,
  view,
  collection,
  school,
  sy,
  status,
  createdBy,
  billingStatus,
  gradeLevel,
  limit, // pageSize
  startAfter, // cursor for next page
  sortBy, // field to sort by
  sortDirection, // asc or desc
}) => {
  return async (dispatch) => {
    dispatch(searchRegistryStart({ keyword, view, collection }));
    const api = process.env.REACT_APP_FUNCTIONS_API;
    const queryParams = new URLSearchParams({
      search: keyword || "",
      school: school || "all",
      sy: sy || "all",
      limit: limit || 50,
      ...(startAfter && { startAfter }),
      ...(sortBy && { sortBy }),
      ...(sortDirection && { sortDirection }),
      ...(status && status !== "all" && { status }),
      ...(createdBy && { createdBy }),
      ...(billingStatus && billingStatus !== "all" && { billingStatus }),
      ...(gradeLevel && gradeLevel !== "all" && { gradeLevel }),
    }).toString();
    const searchEndpoint = `/search/registry/${collection}?${queryParams}`;
    try {
      let response = await fetchWithAuth(api + searchEndpoint);
      if (response.status === 403) {
        throw await response.json();
      }
      let data = await response.json();
      dispatch(
        searchRegistrySuccess({ keyword, view, collection, result: data }),
      );
    } catch (error) {
      console.log(error);
      dispatch(searchRegistryFail({ keyword, view, collection, error }));
    }
  };
};

export const searchEmployee = ({
  keyword,
  view,
  collection,
  school,
  sy,
  teaching,
  limit,
  startAfter,
  sortBy,
  sortDirection,
  gender,
  position,
  role, // New parameter
}) => {
  return async (dispatch) => {
    dispatch(searchRegistryStart({ keyword, view, collection, role }));
    const api = process.env.REACT_APP_FUNCTIONS_API;
    const queryParams = new URLSearchParams({
      search: keyword || "",
      school: school || "all",
      sy: sy || "all",
      teaching: teaching,
      limit: limit || 50,
      ...(startAfter && { startAfter }),
      ...(sortBy && {
        sortBy: sortBy === "roleRank" ? "name.lastName" : sortBy,
      }),
      ...(sortDirection && { sortDirection }),
      ...(gender && gender !== "All" && { gender }),
      ...(position && position !== "All" && { position }),
      ...(role && { role }), // Pass to API
    }).toString();
    const searchEndpoint = `/search/registry/${collection}?${queryParams}`;
    try {
      let response = await fetchWithAuth(api + searchEndpoint);
      let data = await response.json();
      dispatch(
        searchRegistrySuccess({
          keyword,
          view,
          collection,
          result: data,
          role,
        }),
      );
    } catch (error) {
      console.log(error);
      dispatch(searchRegistryFail({ keyword, view, collection, error, role }));
    }
  };
};

export const searchUsers = ({
  keyword,
  role,
  school,
  status,
  view,
  collection,
  limit, // pageSize
  startAfter, // cursor for next page
  sortBy, // field to sort by
  sortDirection, // asc or desc
}) => {
  return async (dispatch) => {
    dispatch(searchRegistryStart({ keyword, view, collection }));
    const api = process.env.REACT_APP_FUNCTIONS_API;
    const queryParams = new URLSearchParams({
      search: keyword || "",
      school: school || "all",
      role: role || "all",
      status: status || "all",
      limit: limit || 50,
      ...(startAfter && { startAfter }),
      ...(sortBy && { sortBy }),
      ...(sortDirection && { sortDirection }),
    }).toString();
    const searchEndpoint = `/search/registry/${collection}?${queryParams}`;
    try {
      let response = await fetchWithAuth(api + searchEndpoint);
      let data = await response.json();
      dispatch(
        searchRegistrySuccess({ keyword, view, collection, result: data }),
      );
    } catch (error) {
      console.log(error);
      dispatch(searchRegistryFail({ keyword, view, collection, error }));
    }
  };
};
